import type { DocumentResponse, CreateDocumentRequest, MarkUploadedRequest } from '@/types/upload';
import { apiRequest } from './apiClient';

/**
 * Play-activity-specific upload API service.
 * Uses the spark-activities upload endpoints (existing route mount, unchanged) which generate S3 keys at playmoments/assets/play-activities/
 */
export const playActivityUploadApi = {
  /**
   * Create a new document for a play activity image and get signed upload URL
   */
  async createDocument(data: CreateDocumentRequest): Promise<DocumentResponse> {
    const result = await apiRequest<{ data: DocumentResponse }>(
      '/admin/spark-activities/upload/create',
      { method: 'POST', body: data }
    );
    return result.data;
  },

  /**
   * Mark play activity document as uploaded
   */
  async markAsUploaded(data: MarkUploadedRequest): Promise<void> {
    await apiRequest<void>('/admin/spark-activities/upload/mark-uploaded', {
      method: 'POST',
      body: data,
    });
  },
};
